import { render, staticRenderFns } from "./RechargeRecordList.vue?vue&type=template&id=3cb38a2e&scoped=true"
import script from "./RechargeRecordList.vue?vue&type=script&lang=js"
export * from "./RechargeRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb38a2e",
  null
  
)

export default component.exports